//METALS Listing
export const FETCH_METALS_LISTING_FAILURE = 'FETCH_METALS_LISTING_FAILURE';
export const FETCH_METALS_LISTING_SUCCESS = 'FETCH_METALS_LISTING_SUCCESS';

export const FETCH_METAL_ITEMS_LISTING_FAILURE = 'FETCH_METAL_ITEMS_LISTING_FAILURE';
export const FETCH_METAL_ITEMS_LISTING_SUCCESS = 'FETCH_METAL_ITEMS_LISTING_SUCCESS';

export const RESET = 'RESET';
